<template>
  <!-- Contractor Add -->
  <b-modal
    id="modalAdd"
    ref="my-modal"
    title="เพิ่มข้อมูลผู้รับเหมา"
    size="1.714rem"
    ok-title="ตกลง"
    cancel-title="ยกเลิก"
    @show="resetModal"
    @hidden="resetModal"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <!-- Name Company -->
        <b-col cols="12">
          <b-form-group
            label="ชื่อบริษัท"
            label-for="Namecompany"
          >
            <validation-provider
              #default="{ errors }"
              name="Name Company"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="vendor_name"
                  v-model="addData.vendor_name"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ชื่อบริษัท"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- address -->
        <b-col cols="12">
          <b-form-group
            label="ที่อยู่"
            label-for="address"
          >
            <validation-provider
              #default="{ errors }"
              name="address"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <textarea
                  id="vendor_address"
                  v-model="addData.vendor_address"
                  style="background-color: rgba(0, 0, 0, 0); color: #fff; width: 100%; height: 80px; border-radius: 5px; border-color: #404656;"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ที่อยู่"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Name -->
        <b-col cols="12">
          <b-form-group
            label="ชื่อ-นามสกุล"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              name="Name"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="vendor_contact_name"
                  v-model="addData.vendor_contact_name"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ชื่อ-นามสกุล"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="เบอร์โทร"
            label-for="tel"
          >
            <validation-provider
              #default="{ errors }"
              name="Tel"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="vendor_contact_tel"
                  v-model="addData.vendor_contact_tel"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="เบอร์โทร"
                  maxlength="12"
                  @input="acceptNumber"
                  @keyup.delete="console.log(1)"
                  @keypress="isLetter2($event)"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- English abbreviations -->
        <b-col cols="12">
          <b-form-group
            label="ชื่อย่อภาษาอังกฤษบริษัท / ชื่อผู้ใช้งาน"
            label-for="englishabbreviations"
          >
            <validation-provider
              #default="{ errors }"
              name="English abbreviations"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="vendor_shortname_english"
                  v-model="addData.vendor_shortname_english"
                  :state="errors.length > 0 ? false:null"
                  required
                  type="text"
                  placeholder="ภาษาอังกฤษเท่านั้น ไม่เกิน 5 ตัวอักษร (ชื่อผู้ใช้งาน)"
                  maxlength="5"
                  @keyup.delete="console.log(1)"
                  @keypress="isLetter($event)"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- password -->
        <b-col cols="12">
          <b-form-group
            label="รหัสผ่าน"
            label-for="password"
          >
            <validation-provider
              #default="{ errors }"
              name="password"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="password"
                  v-model="addData.password"
                  type="password"
                  :state="errors.length > 0 ? false:null"
                  required
                  placeholder="รหัสผ่าน"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="สถานะ"
            label-for="role"
          >
            <validation-provider
              #default="{ errors }"
              name="role"
              rules="required"
            >
              <v-select
                v-model="addData.role"
                :reduce="role => role.role"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :state="errors.length > 0 ? false:null"
                required
                label="role"
                :options="role"
                transition=""
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <template #code>
          {{ codeFeedbackHelper }}
        </template>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BInputGroup, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BInputGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      required,
      role: [],
      password: null,
      vendor_id: '',
      addData: {
        vendor_name: '',
        vendor_shortname_english: '',
        vendor_address: '',
        vendor_contact_name: '',
        vendor_contact_tel: '',
        password: '',
        role: '',
        vendor_id: '',
      },
    }
  },
  mounted() {
    this.VendorID()
    this.dropdownVendorRole()
    this.dropdownVendorDepartment()
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      // this.addData.username = ''
      this.vendor_shortname_english = valid
      this.password = valid
      return valid
    },
    resetModal() {
      this.addData.vendor_name = ''
      this.addData.vendor_shortname_english = ''
      this.addData.vendor_address = ''
      this.addData.vendor_contact_name = ''
      this.addData.vendor_contact_tel = ''
      this.addData.password = ''
      this.addData.role = ''
      this.addData.vendor_id = ''
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      this.addInfo()
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.addInfo()
        this.$nextTick(() => {
          this.$bvModal.hide('modalAdd')
        })
      })
    },

    // เพิ่มข้อมูลปุ่ม Add
    async addInfo() {
      // eslint-disable-next-line global-require
      const bcrypt = require('bcryptjs')
      const hash = bcrypt.hashSync(this.addData.password)
      const payload = {
        ...this.addData,
        vendor_name: this.addData.vendor_name,
        vendor_shortname_english: this.addData.vendor_shortname_english,
        vendor_address: this.addData.vendor_address,
        vendor_contact_name: this.addData.vendor_contact_name,
        vendor_contact_tel: this.addData.vendor_contact_tel,
        password: hash,
        role: this.addData.role,
        vendor_id: this.vendor_id,
      }
      console.log(payload)
      axios
        .post('/addVendor', payload)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">เพิ่มข้อมูลเรียบร้อย.</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.addData.vendor_name = ''
          this.addData.vendor_shortname_english = ''
          this.addData.vendor_address = ''
          this.addData.vendor_contact_name = ''
          this.addData.vendor_contact_tel = ''
          this.addData.password = ''
          this.addData.role = ''
          this.addData.vendor_id = ''
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
          this.addData.vendor_name = ''
          this.addData.vendor_shortname_english = ''
          this.addData.vendor_address = ''
          this.addData.vendor_contact_name = ''
          this.addData.vendor_contact_tel = ''
          this.addData.password = ''
          this.addData.role = ''
          this.addData.vendor_id = ''
        })
    },
    VendorID() {
      axios
        .post('/idVendor')
        .then(response => {
          this.vendor_id = response.data[0].vendor_id
          console.log(this.addData)
        })
    },
    dropdownVendorRole() {
      axios
        .post('/dropdownRole')
        .then(response => {
          // console.log(response.data)
          this.role = response.data
        })
    },

    // eslint-disable-next-line consistent-return
    isLetter(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[A-Za-z]+$/.test(char)) return true
      e.preventDefault()
    },

    acceptNumber() {
      const x = this.addData.vendor_contact_tel.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
      this.addData.vendor_contact_tel = !x[2] ? x[1] : `${x[1]}-${x[2]}${x[3] ? `-${x[3]}` : ''}`
    },
    // eslint-disable-next-line consistent-return
    isLetter2(e) {
      const char = String.fromCharCode(e.keyCode)
      if (/^[0-9]+$/.test(char)) return true
      e.preventDefault()
    },
  },
}
</script>
